import { Flex, Center, Button } from '@chakra-ui/react';
import { NotificationCard } from '../../components/Card';
import { NotificationTime } from '../../components/Time';
import { decode } from 'js-base64';
import { CheckCircle } from '@kula-ai/icons-core';
import {
  CollapsibleSection,
  DetailsList,
} from '../referral-notifications/components';
import { KText } from '@/ui-library/components';

const ApiTokenReset = ({ notification = {}, onClose = () => {} }) => {
  const { custom_attributes } = notification;
  const data = JSON.parse(decode(custom_attributes));
  const {
    token_name,
    token_management_url,
    rotated_by = {},
    rotated_at,
  } = data || {};

  const rotatedByData = [
    { label: 'Token name', value: token_name },
    { label: 'Rotated by', value: rotated_by?.name },
    { label: 'Rotated on', value: rotated_at },
  ];

  const handleGoToApiManagement = () => {
    if (token_management_url) {
      window.open(token_management_url, '_self');
      onClose();
    }
  };

  return (
    <Flex alignItems="baseline" gap="6px">
      <Center minW="34px" h="34px" borderRadius="sm" bg="pastel-2-light">
        <CheckCircle
          size={16}
          color="var(--kula-colors-pastel-2-dark)"
          className="kula-icon"
        />
      </Center>
      <Flex flexDir="column" ml="16px" gap="8px" alignSelf="start" flex="1">
        <KText fontWeight="semiBold">Your Kula API key has been rotated</KText>

        {rotatedByData.length > 0 && (
          <CollapsibleSection title="Details">
            <DetailsList data={rotatedByData} />
          </CollapsibleSection>
        )}

        <Button
          variant="primary"
          onClick={handleGoToApiManagement}
          size="sm"
          w="fit-content"
          data-test-id="go-to-api-management-button"
        >
          Go to API management
        </Button>

        <NotificationTime notification={notification} />
      </Flex>
    </Flex>
  );
};

export const ApiTokenResetNotification = ({
  notification = {},
  onClose = () => {},
}) => {
  return (
    <NotificationCard notification={notification}>
      <ApiTokenReset notification={notification} onClose={onClose} />
    </NotificationCard>
  );
};
